import {
  MUSIC_VIDEO_DEMO_HEIGHT_MESSAGE,
  type MusicVideoDemoHeightMessage,
} from 'fym-shared/src/music24/musicVideoShowcase';

/** Below this frame width the editor draws its phone layout (`useIsPhoneLayout`). */
const PHONE_WIDTH_PX = 720;

/**
 * The height that the embedded demo asks for. The editor fills its frame: the top bar, the panels
 * with the preview and the timeline need about 760 px; the phone layout stacks the player, the
 * sections and the tabs, so it is taller. The website shows a poster below 720 px, so the phone
 * height is only a safe value. Pure.
 */
export function musicVideoDemoHeightFor(frameWidth: number): number {
  return frameWidth < PHONE_WIDTH_PX ? 860 : 760;
}

/** The height message of the demo (music24-website reads it). Whole pixels, never below 0. Pure. */
export function musicVideoDemoHeightMessage(frameWidth: number): MusicVideoDemoHeightMessage {
  return {
    type: MUSIC_VIDEO_DEMO_HEIGHT_MESSAGE,
    height: Math.max(0, Math.round(musicVideoDemoHeightFor(frameWidth))),
  };
}
